import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { featurePointsHolidaysEdit_template } from "../components/templates/featurePointsHolidaysEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;

export class featurePointsHolidays_edit extends vnModule_knockoutJS{
    protected validationsList: validationsList_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected featurePointsHolidaysEditTemplate: featurePointsHolidaysEdit_template;

    protected getModuleName(){
        return "featurePointsHolidays_edit";
    }

    buildContent() : Array<Element>{

        this.featurePointsHolidaysEditTemplate = new featurePointsHolidaysEdit_template( "featurePointsHolidaysEdit_template", this.viewModel, this );

        return [this.featurePointsHolidaysEditTemplate.build()];
    }

    public fillPage() : void{
        this.getListData();
    }

    public getListData(): void{
        this.loadingIn(this.featurePointsHolidaysEditTemplate.builtTemplate.children.namedItem("list-results"));
        this.featurePointsHolidaysEditTemplate.getTemplateViewModel().isResultsLoading(1);

        /*if( "getListData" in this.XHRHdls ){
            this.XHRHdls["getListData"].cancelAndReset();
        }*/

        let year: number;
        let quarter: string;

        if( (year = this.getVnAppZone().app.params.year) && !isNaN(year)
            && (quarter = this.getVnAppZone().app.params.quarter) && isNaN(Number(quarter))
        ) {
            this.updateViewModel(year,quarter);
            let subViewModel = this.featurePointsHolidaysEditTemplate.getViewModelForRequest();

            let usrReq_url: string = '/api/featurePoints/config/holidays/year/'+year+'/quarter/'+quarter+'/get/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)] );
            this.XHRHdls["getListData"] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

            this.XHRHdls["getListData"].onReadyStateFunction = this.onDataRequestReturn;
            this.XHRHdls["getListData"].execute();

        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsHolidaysEditTemplate.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.featurePointsHolidaysEditTemplate.getTemplateViewModel().isResultsLoading(0);
                obj.loadingOut(obj.featurePointsHolidaysEditTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateList(responseParsed: any) {
        this.featurePointsHolidaysEditTemplate.setHolidaysPeriods(responseParsed.data);
        this.featurePointsHolidaysEditTemplate.setHolidaysCalendarMinMaxDates(responseParsed.quarterDates);
    }

    protected save(): void {

        let year: number;
        let quarter: string;

        if( (year = this.getVnAppZone().app.params.year) && !isNaN(year)
            && (quarter = this.getVnAppZone().app.params.quarter) && isNaN(Number(quarter))
        ) {
            let formReq_url: string = '/api/featurePoints/config/holidays/year/'+year+'/quarter/'+quarter+'/save/';
            let formReq_params: Array<Array<string>> = [];

            let subViewModel = JSON.parse(ko.toJSON(this.featurePointsHolidaysEditTemplate.getViewModelForRequest()));

            formReq_params.push(["data", ko.toJSON(subViewModel)]);

            let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

            XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
            XHRHdl.onReadyStateFunction = this.onPostHolidaysData;
            XHRHdl.execute();
        }
    }

    protected cancelHolidayEdit(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");

        page.redirect('/feature_points/config/view');
    }

    protected saveHolidayEdit() {
        this.save();
    }

    private onPostHolidaysData(req, obj) {
        return function() {

            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Holidays data saved successfully!");
                page.redirect('/feature_points/config/view');

            });
        }
    }

    private updateViewModel(year,quarter){
        this.featurePointsHolidaysEditTemplate.setYear(year);
        this.featurePointsHolidaysEditTemplate.setQuarter(quarter);
    }
}


// WEBPACK FOOTER //
// ./js/modules/featurePointsHolidays_edit.ts